import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import AddOnItem from '../../routes/audiences/AudienceUpsell/AddOnItem';
import { currency } from '../../utils';
import Button from '../inputs/Button';
import { useOrder } from '../../hooks/useOrder';
import { getProduct } from '../../helpers/products';
import AsyncFiltersDisplay from '../AsyncFiltersDisplay';
import MyOrderCard from '../../components/payments/MyOrderCard';
import { useAuth } from '../../hooks/useAuth';

export default function MyOrder({
  showCheckoutBtn = true,
  showCoreProductDetails = true,
}) {
  const { state } = useOrder();
  const {
    orderDetails,
    totalPrice,
    products,
    loading,
    loadingRemoveFromOrder,
    loadingAddOnToOrder,
  } = state;
  const { audienceName, recordsIncluded, orderId } = orderDetails;

  const { user } = useAuth();
  const { plan } = user;

  const { id: audienceProductId } = getProduct('audience', plan);
  const foundAudienceProduct = products?.find(
    (p) => p.id === audienceProductId
  );

  const addOnProducts = products?.filter((p) => p.id !== audienceProductId);
  const { foundEmailAddOn, foundIPAddOn, foundPhoneAddOn } = useMemo(() => {
    const foundIdentifiersBundleAddOn = addOnProducts.find(
      ({ id }) => id === getProduct('identifierBundleAddOn')?.id
    );
    return {
      foundEmailAddOn: Boolean(
        foundIdentifiersBundleAddOn ||
          addOnProducts.find(({ id }) => id === getProduct('emailAddOn')?.id)
      ),
      foundIPAddOn: Boolean(
        foundIdentifiersBundleAddOn ||
          addOnProducts.find(({ id }) => id === getProduct('ipAddOn')?.id)
      ),
      foundPhoneAddOn: Boolean(
        foundIdentifiersBundleAddOn ||
          addOnProducts.find(({ id }) => id === getProduct('phoneAddOn')?.id)
      ),
    };
  }, [addOnProducts]);

  const navigate = useNavigate();

  return (
    <div className="flex flex-col p-2 ml-4" style={{ minWidth: 300 }}>
      <div className="mb-2">
        {/*<h4 className="mb-0">My Order</h4>*/}
      </div>
      <div className="flex flex-col bg-gray-100 rounded-half p-4 space-y-4">
        <MyOrderCard>
          <p className="text-lg font-bold mr-1">
            Audience:{' '}
            <span className="whitespace-nowrap font-normal">
              {audienceName}
            </span>
          </p>

          <div className="flex justify-between mt-3">
            {recordsIncluded ? (
              <p className="italic">
                {parseFloat(recordsIncluded).toLocaleString(undefined, {
                  maximumFractionDigits: 0,
                })}{' '}
                Records
              </p>
            ) : (
              <p></p>
            )}
            <p>
              {' '}
              {foundAudienceProduct?.discount ? (
                <>
                  <span className="line-through text-gray-400 mr-1">
                    {currency(foundAudienceProduct?.amount)}
                  </span>
                  {currency(
                    foundAudienceProduct?.amount -
                      foundAudienceProduct?.discount
                  )}
                </>
              ) : (
                currency(foundAudienceProduct?.amount)
              )}
            </p>
          </div>
          {showCoreProductDetails && (
            <div className="mt-3">
              <p className="text-lg font-bold">Audience Details</p>
              <div className="flex overflow-auto">
                <AsyncFiltersDisplay audienceName={audienceName} />
              </div>
            </div>
          )}
        </MyOrderCard>
        {/*Former Add-Ons section - IP, Email Address etc. Unnused in this client*/}
        {/*<MyOrderCard>*/}
        {/*  <p className="text-lg font-bold">Add-Ons:</p>*/}
        {/*  {addOnProducts?.length === 0 && (*/}
        {/*    <p className="italic text-sm">None selected</p>*/}
        {/*  )}*/}
        {/*  {addOnProducts?.length > 0 &&*/}
        {/*    addOnProducts.map((addOnProduct, idx) => (*/}
        {/*      <div key={idx}>*/}
        {/*        <AddOnItem product={addOnProduct} />*/}
        {/*      </div>*/}
        {/*    ))}*/}
        {/*</MyOrderCard>*/}
        <MyOrderCard>
          <div className="flex justify-between text-lg font-bold">
            <span className="mr-1">Total Price:</span>
            <span>{currency(totalPrice)}</span>
          </div>
        </MyOrderCard>
      </div>
      {showCheckoutBtn && (
        <div className="pt-5">
          <Button
            className="w-full"
            type="text"
            primary
            onClick={() =>
              navigate('../distribution', {
                state: {
                  orderDetails: { ...orderDetails, orderId },
                },
              })
            }
            disabled={loading || loadingRemoveFromOrder || loadingAddOnToOrder}
          >
            Checkout
          </Button>
        </div>
      )}
    </div>
  );
}
